<template>
  <div>
    <b-row align-h="end">
      <b-col cols="auto">
        <b-button
          variant="primary"
          @click="openModal(null, true)"
        >
          <feather-icon icon="PlusIcon" />
          Nova Inbox
        </b-button>
      </b-col>
    </b-row>

    <!-- Modal para criar/editar inbox -->
    <b-modal
      ref="modalInbox"
      size="lg"
      hide-footer
      :title="novoInbox ? 'Nova Inbox Chatwoot' : 'Editar Inbox Chatwoot'"
    >
      <b-form @submit.prevent="submitForm">
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="Nome da Inbox"
              label-for="nome"
            >
              <b-form-input
                id="nome"
                v-model="inbox.nome"
                placeholder="Digite o nome da inbox"
                required
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label="Chatwoot ID"
              label-for="chatwoot_id"
            >
              <b-form-input
                id="chatwoot_id"
                v-model="inbox.chatwoot_id"
                type="number"
                placeholder="Digite o ID do Chatwoot"
                required
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label="Tipo"
              label-for="tipo"
            >
              <b-form-input
                id="tipo"
                v-model="inbox.tipo"
                placeholder="Ex: whatsapp, email, etc."
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label="Status"
              label-for="status"
            >
              <b-form-select
                id="status"
                v-model="inbox.status"
                :options="statusOptions"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            class="d-flex justify-content-end"
          >
            <b-button
              variant="outline-secondary"
              class="mr-1"
              @click="closeModal"
            >
              Cancelar
            </b-button>
            <b-button
              variant="primary"
              type="submit"
            >
              {{ novoInbox ? 'Criar' : 'Atualizar' }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <b-row class="mt-2">
      <b-col>
        <b-row align-h="center">
          <b-col cols="8">
            <b-form-input
              v-model="tableInbox.filter"
              type="search"
              placeholder="Pesquisar"
              class="mb-2"
              size="sm"
            />
          </b-col>
        </b-row>
        <b-table
          hover
          bordered
          striped
          responsive
          :filter="tableInbox.filter"
          :current-page="tableInbox.currentPage"
          :per-page="tableInbox.perPage"
          :fields="tableInbox.fields"
          :items="tableInbox.items"
        >
          <template #cell(status)="data">
            <b-badge :variant="data.item.status === 'ativo' ? 'success' : 'secondary'">
              {{ data.item.status || 'N/A' }}
            </b-badge>
          </template>
          <template #cell(tipo)="data">
            {{ data.item.tipo || 'N/A' }}
          </template>
          <template #cell(detalhes)="data">
            <b-row align-v="center">
              <b-col cols="auto">
                <feather-icon
                  class="color-icon mr-1 cursor-pointer"
                  icon="EditIcon"
                  @click="editarInbox(data.item)"
                />
              </b-col>
              <b-col cols="auto">
                <feather-icon
                  class="trash-icon cursor-pointer"
                  icon="TrashIcon"
                  @click="deleteInbox(data.item)"
                />
              </b-col>
            </b-row>
          </template>
        </b-table>
        <b-pagination
          v-model="tableInbox.currentPage"
          :total-rows="tableInbox.totalRows"
          :per-page="tableInbox.perPage"
          align="center"
          size="sm"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BTable,
  BPagination,
  VBModal,
  BModal,
  BFormInput,
  BBadge,
  BForm,
  BFormGroup,
  BFormSelect,
} from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import axios from '@/../axios-auth'

export default {
  components: {
    FeatherIcon,
    BRow,
    BCol,
    BButton,
    BModal,
    BTable,
    BPagination,
    BFormInput,
    BBadge,
    BForm,
    BFormGroup,
    BFormSelect,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      novoInbox: true,
      tableInbox: {
        filter: '',
        fields: [
          { key: 'id', label: 'ID', sortable: true },
          { key: 'nome', label: 'Nome', sortable: true },
          { key: 'chatwoot_id', label: 'Chatwoot ID', sortable: true },
          { key: 'tipo', label: 'Tipo', sortable: true },
          { key: 'status', label: 'Status', sortable: true },
          { key: 'detalhes', label: 'Ações', class: 'text-center' },
        ],
        items: [],
        totalRows: 1,
        perPage: 10,
        currentPage: 1,
      },
      inbox: {
        nome: '',
        chatwoot_id: null,
        tipo: '',
        status: 'ativo',
      },
      statusOptions: [
        { value: 'ativo', text: 'Ativo' },
        { value: 'inativo', text: 'Inativo' },
      ],
    }
  },
  created() {
    this.getInboxes()
  },
  methods: {
    clearCamposInbox() {
      this.inbox = {
        nome: '',
        chatwoot_id: null,
        tipo: '',
        status: 'ativo',
      }
    },
    openModal(inboxData, isNew) {
      this.novoInbox = isNew
      if (inboxData) {
        this.inbox = { ...inboxData }
      } else {
        this.clearCamposInbox()
      }
      this.$refs.modalInbox.show()
    },
    closeModal() {
      this.clearCamposInbox()
      this.$refs.modalInbox.hide()
    },
    editarInbox(item) {
      this.openModal(item, false)
    },
    async getInboxes() {
      this.tableInbox.items = []
      await axios.get('api/v1/chatwoot_inboxes', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      })
        .then(res => {
          this.tableInbox.items = res.data.dados
          this.tableInbox.items.sort((a, b) => {
            const dateA = a.updated_at ? new Date(a.updated_at) : new Date(a.created_at || 0)
            const dateB = b.updated_at ? new Date(b.updated_at) : new Date(b.created_at || 0)
            return dateB - dateA
          })
          this.tableInbox.totalRows = this.tableInbox.items.length
        })
        .catch(error => {
          this.$swal({
            title: 'Erro!',
            text: error.response?.data?.mensagem || 'Erro ao buscar inboxes',
            icon: 'error',
          })
        })
    },
    deleteInbox(item) {
      this.$swal({
        title: 'Tem certeza?',
        text: `Deseja deletar a inbox "${item.nome}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, quero deletar!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          axios.delete(`api/v1/chatwoot_inboxes/delete/${item.id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          })
            .then(res => {
              if (res.data) {
                this.getInboxes()
                this.$swal({
                  icon: 'success',
                  title: 'Deletado!',
                  text: 'Inbox deletada com sucesso!',
                  timer: 1500,
                  showConfirmButton: false,
                })
              }
            })
            .catch(error => {
              this.$swal({
                title: 'Erro!',
                text: error.response?.data?.mensagem || 'Erro ao deletar inbox',
                icon: 'error',
              })
            })
        }
      })
    },
    submitForm() {
      if (this.novoInbox) {
        this.createInbox()
      } else {
        this.updateInbox()
      }
    },
    createInbox() {
      axios.post('api/v1/chatwoot_inboxes/store', this.inbox, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      })
        .then(() => {
          this.getInboxes()
          this.$refs.modalInbox.hide()
          this.$swal({
            icon: 'success',
            title: 'Criado!',
            text: 'Inbox criada com sucesso!',
            timer: 1500,
            showConfirmButton: false,
          })
        })
        .catch(error => {
          this.$swal({
            title: 'Erro!',
            text: error.response?.data?.mensagem || 'Erro ao criar inbox',
            icon: 'error',
          })
        })
    },
    updateInbox() {
      axios.put(`api/v1/chatwoot_inboxes/update/${this.inbox.id}`, this.inbox, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      })
        .then(() => {
          this.getInboxes()
          this.$refs.modalInbox.hide()
          this.$swal({
            icon: 'success',
            title: 'Atualizado!',
            text: 'Inbox atualizada com sucesso!',
            timer: 1500,
            showConfirmButton: false,
          })
        })
        .catch(error => {
          this.$swal({
            title: 'Erro!',
            text: error.response?.data?.mensagem || 'Erro ao atualizar inbox',
            icon: 'error',
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.color-icon {
  color: #7367f0;
  &:hover {
    color: #5e50ee;
  }
}

.trash-icon {
  color: #ea5455;
  &:hover {
    color: #e42728;
  }
}

.cursor-pointer {
  cursor: pointer;
}
</style>
